import { Exclude } from 'class-transformer'

import {
  GroupedBotProperty,
} from '../../../../../../../../../BotProperties/components/Properties/types'
import { DelayPropertyType } from '../../DelayTypes'
import { DelayDataLimitType, DelayType } from '../../DelayTypes/types'
import { ProxyBaseDelayTypeWithInterval } from './ProxyBaseDelayType'

export class ProxyDelayPropertyType extends ProxyBaseDelayTypeWithInterval {
  type: DelayType.Property = DelayType.Property
  property_index: number | null
  offset: number
  limit: DelayDataLimitType | null

  @Exclude()
  getProperties: () => Array<GroupedBotProperty>

  constructor({ property_index, offset, limit }: DelayPropertyType, props: {
    getProperties: () => Array<GroupedBotProperty>
  }) {
    super()

    this.getProperties = props.getProperties

    this.property_index = property_index
    this.offset = offset
    this.limit = limit
  }

  setOffset(offset: number): void {
    this.offset = offset
  }

  setProperty(index: number): void {
    this.property_index = index
  }

  getModel(): DelayPropertyType {
    return this
  }
}
